import secondaryButtonLightGrayHover from '../../../../../common/algorithms/secondary-button-light-gray-hover';

const dark = (params) => secondaryButtonLightGrayHover(params);

export default dark;
